export const extractInnerData = (data: any) => data?.data?.data

export const extractData = (data: any) => data?.data
